import { render, staticRenderFns } from "./HomeFeedGuidelineChild.vue?vue&type=template&id=804fb6da&scoped=true"
import script from "./HomeFeedGuidelineChild.vue?vue&type=script&lang=js"
export * from "./HomeFeedGuidelineChild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804fb6da",
  null
  
)

export default component.exports